<template>
  <div
    id="authors"
  >
    <h2>
      Authors
    </h2>

    <author-nav />

    <author-search
      label="Name/Email"
      userType="authors"
      filterByFeatured
    />

    <pagination
      :pageResponse="pageResponse"
      :pageSize="$root.defaultPageSize"
      :resourceUrl="resourceUrl"
      orderBy="name"
      orderType="ASC"
      ref="pagination"
      attrIncludes
      preserveHistory
    >
      <template
        slot="paged_item"
        slot-scope="item"
      >
        <router-link
          :to="{
            name: 'author',
            params: {
              authorId: item.id
            }
          }"
          class="list-group-item list-group-item-action"
        >
          {{ item.name || item.username }}
          <span
            class="badge badge-primary"
            v-if="item.visible"
          >
            Visible
          </span>
          <span
            class="badge badge-info"
            v-if="item.verified"
          >
            Verified
          </span>
          <span
            class="badge badge-warning"
            v-if="item.featured"
          >
            Featured
          </span>
        </router-link>
      </template>
    </pagination>
  </div>
</template>
<script>
import AuthorNav from '@/components/AuthorNav'
import UserSearch from '@/components/UserSearch'

import Pagination from 'sai-vue-kaminari'

export default {
  data () {
    return {
      pageResponse: {}
    }
  },

  components: {
    'author-nav': AuthorNav,
    'author-search': UserSearch,
    pagination: Pagination
  },

  computed: {
    resourceUrl () {
      return this.apiUrl('/authors', true)
    }
  },

  methods: {
    created () {
      this.$on('searchComplete', this.processPagedResponse)
    },

    processPagedResponse (response) {
      this.$emit('processPagedResponse', response)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Authors.vue